import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsComponent } from './journey/departments/departments.component';
import { LoginComponent } from './journey/login/login.component';
import { ServicesComponent } from './journey/services/services.component';
import { LocationComponent } from './journey/location/location.component';
import { CalendarComponent } from './journey/calendar/calendar.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { SummaryComponent } from './journey/summary/summary.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { DeepLinksComponent } from './journey/deeplink/deeplink.component';
import { PermitsComponent } from './journey/permits/permits.component';
import { PermitsSubmittedComponent } from './journey/permits-submitted/permits-submitted.component';
import { AmendPermitsComponent } from './journey/amend-permits/amend-permits.component';
import { CapitaVerifyPaymentComponent } from './journey/capita-verify-payment/capita-verify-payment.component';
import { SessionComponent } from './journey/session/session.component';
import { AmendPermitsSubmittedComponent } from './journey/amend-permits-submitted/amend-permits-submitted.component';
import { CookiePolicyComponent } from '@bookinglab/hwrc-ui';
import { AccessibilityStatementComponent } from './journey/accessibility-statement/accessibility-statement.component';
import { PrivacyStatementComponent } from './journey/privacy-statement/privacy-statement.component';
import { CheckPermitComponent } from './journey/check-permit/check-permit.component';

const routes: Routes = [
  { path: '', component: DeepLinksComponent },
  { path: 'departments', component: DepartmentsComponent },
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  {
    path: 'services',
    component: ServicesComponent,
    data: { breadcrumb: 'Services' },
  },
  { path: 'locations', component: LocationComponent },
  { path: 'permits', component: PermitsComponent },
  { path: 'amend-permits', component: AmendPermitsComponent },
  { path: 'amend-permits-submitted', component: AmendPermitsSubmittedComponent },
  { path: 'permits-submitted', component: PermitsSubmittedComponent },
  { path: 'permit-check', component: CheckPermitComponent },
  {
    path: 'payment-verify', component: CapitaVerifyPaymentComponent,
  },
  {
    path: 'calendar',
    component: CalendarComponent,
    data: { breadcrumb: 'Date & Time' },
  },
  {
    path: 'booking-details',
    component: BookingDetailsComponent,
    data: { breadcrumb: 'Booking Form' },
  },
  {
    path: 'summary',
    component: SummaryComponent,
    data: { breadcrumb: 'Summary' },
  },
  {
    path: 'confirmation',
    component: ConfirmationComponent,
    data: { breadcrumb: 'Confirmation' },
  },
  { path: 'sessionExpired', component: SessionComponent },
  { path: 'cookies', component: CookiePolicyComponent },
  { path: 'accessibility-statement', component: AccessibilityStatementComponent },
  { path: 'privacy-statement', component: PrivacyStatementComponent }

  // { path: 'register', component: RegisterComponent },
  // { path: 'account', component: MainAccountComponent, canActivate: [AccountGuardService] },
  // { path: 'account-login', component: AccountLoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
